import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import Estatuto from './Estatuto';
import Lgpd from './Lgpd';
import Nav from 'react-bootstrap/Nav';
import { Tab } from "react-bootstrap";
import * as FaIcons from "react-icons/fa";
import * as FcIcons from "react-icons/fc";

const Normas = () => {

    const location = useLocation();

    useEffect(() => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        });
    }, [location.pathname]);

    const [activeTab, setActiveTab] = useState('/estatuto');

    const handleTabSelect = (selectedTab) => {
        setActiveTab(selectedTab);
    };
    return (
        <div><br />
            <Tab.Container activeKey={activeTab} onSelect={handleTabSelect}>
                <Nav fill variant="tabs" defaultActiveKey="/estatuto">
                    <Nav.Item>
                        <Nav.Link eventKey="/estatuto">
                            <div className='aba-menu'>
                                <h4><FcIcons.FcAbout /></h4>
                                <h5>Diretrizes</h5>
                            </div>
                        </Nav.Link>
                    </Nav.Item>
                    <Nav.Item>
                        <Nav.Link eventKey="/lgpd">
                            <div className='aba-menu'>
                            <h4><FaIcons.FaGavel /></h4>
                             <h5>LGPD</h5>
                            </div>
                        </Nav.Link>
                    </Nav.Item>
                </Nav>
                <Tab.Content>
                    <Tab.Pane eventKey="/estatuto">
                        <Estatuto />
                    </Tab.Pane>
                    <Tab.Pane eventKey="/lgpd">
                        <Lgpd />
                    </Tab.Pane>
                </Tab.Content>
            </Tab.Container>
        </div>
    );
}
export default Normas;